const IconShoppingBagFilled = ({ width, height, size, color, ...props }) => (
    <svg
        width={width || size}
        height={height || size}
        viewBox="0 0 13 15"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M4.875 3.8125C4.875 2.85547 5.64062 2.0625 6.625 2.0625C7.58203 2.0625 8.375 2.85547 8.375 3.8125V5.125H4.875V3.8125ZM3.5625 5.125H1.8125C1.07422 5.125 0.5 5.72656 0.5 6.4375V12.125C0.5 13.5742 1.67578 14.75 3.125 14.75H10.125C11.5742 14.75 12.75 13.5742 12.75 12.125V6.4375C12.75 5.72656 12.1484 5.125 11.4375 5.125H9.6875V3.8125C9.6875 2.14453 8.29297 0.75 6.625 0.75C4.92969 0.75 3.5625 2.14453 3.5625 3.8125V5.125ZM4.21875 7.75C3.83594 7.75 3.5625 7.47656 3.5625 7.09375C3.5625 6.73828 3.83594 6.4375 4.21875 6.4375C4.57422 6.4375 4.875 6.73828 4.875 7.09375C4.875 7.47656 4.57422 7.75 4.21875 7.75ZM9.6875 7.09375C9.6875 7.47656 9.38672 7.75 9.03125 7.75C8.64844 7.75 8.375 7.47656 8.375 7.09375C8.375 6.73828 8.64844 6.4375 9.03125 6.4375C9.38672 6.4375 9.6875 6.73828 9.6875 7.09375Z"
            fill={color}
        />
    </svg>
);

export default IconShoppingBagFilled;
